// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T5xK","title":"styles_title__3rCdG"};